import * as React from 'react'
import { Field } from 'formik'
import { MuiTextFieldFormik } from '@user/components/Formik'
import {
  ISalesFunnel,
  ISalesFunnelStage,
} from '@user/store/salesFunnel/typings'
import { ENTITY_TYPES } from '@sales-center/common'
import { ClosedReasonField } from './ClosedReasonField'
import { useFormFieldActions, useValidateRows } from './hooks'
import { ValidationCallback } from './typings'
import { RowErrors } from './RowErrors'

import MenuItem from '@mui/material/MenuItem'
import CircularProgress from '@mui/material/CircularProgress'

export type FormFieldsProps = {
  entityType: ENTITY_TYPES
  salesFunnels: ISalesFunnel[]
  salesFunnelStages: ISalesFunnelStage[]
  validateRows: ValidationCallback
}

export const FormFields: React.FC<FormFieldsProps> = (props) => {
  const { salesFunnels, validateRows, entityType } = props

  const validationStatus = useValidateRows(validateRows)

  const {
    activeStages,
    closedReasons,
    closedReasonsLoading,
    displayClosedReasons,
    disableInteraction,
    onChangeSalesFunnelId,
    onChangeSalesFunnelStageId,
    onCustomReasonFocus,
  } = useFormFieldActions(props)

  return (
    <>
      <Field
        component={MuiTextFieldFormik}
        name="salesFunnelId"
        label="Sales Funnel"
        disabled={disableInteraction}
        onChange={onChangeSalesFunnelId}
        select
        required
        size="small"
        margin="normal"
      >
        {salesFunnels.map((f) => (
          <MenuItem key={f.id} value={f.id}>
            {f.name}
          </MenuItem>
        ))}
      </Field>

      <Field
        component={MuiTextFieldFormik}
        name="salesFunnelStageId"
        label="Funnel Stage"
        disabled={disableInteraction}
        onChange={onChangeSalesFunnelStageId}
        select
        required
        size="small"
        margin="normal"
      >
        {activeStages.length === 0 && (
          <MenuItem disabled>Select Sales Funnel</MenuItem>
        )}
        {activeStages.map((s) => (
          <MenuItem key={s.id} value={s.id}>
            {s.name}
          </MenuItem>
        ))}
      </Field>

      {displayClosedReasons &&
        (closedReasonsLoading ? (
          <CircularProgress color="primary" />
        ) : (
          !!closedReasons && (
            <ClosedReasonField
              entityType={entityType}
              closedReasons={closedReasons}
              onCustomReasonFocus={onCustomReasonFocus}
            />
          )
        ))}

      <RowErrors {...validationStatus} />
    </>
  )
}
FormFields.displayName = 'FormFields'
